import MeasurementRepository from '@/shared/http/repositories/socialProject/student-measurement'
import GymRatingDeadLiftRepository from '@/shared/http/repositories/socialProject/gymRating-deadLift'
import GymRatingRepository from '@/shared/http/repositories/socialProject/gymRating'
import MeasurementModel from '@/shared/models/measurementModel'
import GymRatingDeadLiftModel from '@/shared/models/gymRatingDeadLift'
import { loading, toast } from '@/shared/utils/UIHelper'
import { IsSuccessCode } from '@/shared/utils/API'
import download from 'downloadjs'

export default {
  name: 'GymDeadLift',

  props: {
    items: {
      type: Object,
      default: {}
    }
  },

  data: () => ({
    gymRatingDeadlift: new GymRatingDeadLiftModel(),
    measurement: new MeasurementModel(),
    emptyText: 'Não há nada para exibir',
    classAverageFeminine: 0,
    totalRegister: 0,
    classAverage: 0,
    enableExportButtonFemale: false,
    showModalDeleteDeadLift: false,
    showModalMeasurement: false,
    showInputDeadLift: false,
    studentId: null,
    studentName: '',
    literature: null,
    selected: {},
    studentsDeadLift: [],
    fieldsGymDeadLift: [
      {
        key: 'studentName',
        label: 'NOME',
        class: 'left-header-border text-center',
        sortable: true
      },
      {
        key: 'weight',
        label: 'PESO CORPORAL (KG)',
        class: 'middle-header text-center'
      },
      {
        key: 'deadLift',
        label: 'TERRA',
        class: 'middle-header text-center',
        sortable: true
      },
      {
        key: 'percentWeight',
        label: '% AO PESO',
        class: 'middle-header text-center',
        formatter: 'calculatePercentWeight'
      },
      {
        key: 'situation',
        label: 'RELAÇÃO',
        class: 'middle-header text-center',
        formatter: 'checkSituation'
      },
      {
        key: 'action',
        label: 'AÇÕES',
        class: 'right-header-border text-center'
      }
    ],
    pagination: {
      count: 1,
      limit: 15,
      index: 1
    }
  }),

  watch: {
    items: {
      handler: function (value) {
        if (value.id) {
          this.GetByGymRatingId(value.id)
        }
      },
      immediate: true
    }
  },

  methods: {
    GetByGymRatingId(id) {
      loading.push()
      GymRatingDeadLiftRepository.GetGymRatingDeadLiftByGymRatingId(id, this.pagination)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.studentsDeadLift = res.data.data

          const haveStudentFemale = this.studentsDeadLift.find(x => x.studentGender == 'Feminino')
          if (haveStudentFemale && this.items.category == 'JUNIOR E SENIOR') { 
            this.enableExportButtonFemale = true
            this.$emit('onShowGraphicDeadLiftFeminine', true)
          } 
          else {
            this.enableExportButtonFemale = false 
            this.$emit('onShowGraphicDeadLiftFeminine', false)
          }
          this.pagination = {
            count: res.data.count,
            limit: res.data.pagingLimit,
            index: res.data.pagingIndex
          }

          if (res.data.count > 0) {
            this.totalRegister = res.data.count
          } else {
            this.totalRegister = 0
          }

          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao carregar tabela terra', 'ERRO')
        })
    },

    onSaveCreate(text) {
      if (text == 'yesValidation') {
        const deadLift = this.gymRatingDeadlift.deadLift
        const weight = this.gymRatingDeadlift.weight
  
        if (!deadLift || !weight) {
          toast.info('Preencha os campos', 'AVISO')
          return
        }
      }

      loading.push()
      GymRatingDeadLiftRepository.Update(this.gymRatingDeadlift)
        .then(result => {
          if (!IsSuccessCode(result)) return Promise.reject()
          this.showInputDeadLift = false
          this.$emit('reloadGraphicDeadLift', this.items.id, this.items.category)

          if (text == 'yesValidation') {
            this.GetByGymRatingId(this.items.id)
          }
          
          loading.pop()
        })
        .catch(() => {
          toast.error('Não foi possível salvar registro.', 'ERRO')
          loading.pop()
        })
    },

    GetById() {
      loading.push()
      GymRatingDeadLiftRepository.GetById(this.gymRatingDeadlift.id)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.gymRatingDeadlift = new GymRatingDeadLiftModel(res.data.data)

          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao carregar tabela terra', 'ERRO')
        })
    },

    createStudentMeasurement() {
      const height = this.measurement.height
      const weight = this.measurement.weight

      if (!height || !weight) {
        toast.info('Preencha os campos', 'AVISO')
        return
      }

      this.gymRatingDeadlift.weight = weight

      loading.push()
      MeasurementRepository.Create(this.studentId, this.measurement)
      .then(res => {
        if (!IsSuccessCode(res)) return Promise.reject()
        
        this.gymRatingDeadlift.deadLift = null
        this.onSaveCreate('noValidation')

        this.onSaveWeightCategories(this.items.id, this.studentId, this.gymRatingDeadlift.weight, this.measurement.height)

        this.showModalMeasurement = false
        
        toast.success('Medida criada com sucesso!', 'CRIAÇÃO DE MEDIÇÃO')
        loading.pop()
        return Promise.resolve()
      })
      .catch(() => {
        loading.pop()
        toast.error('Erro ao criar medida', 'ERRO')
      })
    },

    onSaveWeightCategories(gymRatingId, studentId, weight, height) {
      loading.push()
      GymRatingRepository.SaveWeightOnTables(gymRatingId, studentId, weight, height)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.onClearModalMeasurement()
          this.onClearModalInputDeadLift()

          this.GetByGymRatingId(this.items.id)
          this.$emit('reloadAllTables')

          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao salvar peso nas tabelas', 'ERRO')
        })
    },

    checkModal(item) {
      this.gymRatingDeadlift.id = item.id
      this.studentName = item.studentName

      if (item.weight == null) {
        this.studentId = item.studentId
        this.measurement.height = null
        this.measurement.weight = null
        this.showModalMeasurement = true
        return
      }

      this.studentId = null
      this.GetById()
      this.showInputDeadLift = true
    },

    calculatePercentWeight(value, key, item) {
      const weight = item.weight
      const deadLift = item.deadLift
      
      if (!deadLift || !weight){
        return value = '-'
      }

      const calc1 = item.deadLift / item.weight
      const calc2 = calc1 * 100
      const result = Number.parseFloat(calc2).toFixed(2)

      return value = `${result} %`
    },

    checkSituation(value, key, item) {
      const weight = item.weight
      const deadLift = item.deadLift
      
      if (!deadLift || !weight){
        return value = '-'
      }

      const category = this.items.category

      const calc1 = item.deadLift / item.weight
      const calc2 = calc1 * 100
      const result = Number.parseFloat(calc2).toFixed(2)

      if (category === 'JUVENIL I' || category === 'JUVENIL II') {
        const literature = this.items.juvenileDeadliftLiterature
        const literaturePercent = literature * 100

        if (result > literaturePercent) {
          const text = 'Acima do Esperado'
          return value = text
        }

        if (result == literaturePercent) {
          const text = 'Na Média'
          return value = text
        }

        if (result < literaturePercent) {
          const text = 'Abaixo do Esperado'
          return value = text
        }
      }

      // Junior e Senior
      if (item.studentGender == 'Feminino') {
        const literatureFeminine = this.items.feminineDeadliftLiterature
        const literaturePercent = literatureFeminine * 100

        if (result > literaturePercent) {
          const text = 'F/ - Acima do Esperado'
          return value = text
        }

        if (result == literaturePercent) {
          const text = 'F/ - Na Média'
          return value = text
        }

        if (result < literaturePercent) {
          const text = 'F/ - Abaixo do Esperado'
          return value = text
        }
      }

      if (item.studentGender == 'Masculino') {
        const literatureMasculine = this.items.masculineDeadliftLiterature
        const literaturePercent = literatureMasculine * 100
        
        if (result > literaturePercent) {
          const text = `${'M/ - Acima do Esperado'}`
          return value = text
        }

        if (result == literaturePercent) {
          const text = 'M/ - Na Média'
          return value = text
        }

        if (result < literaturePercent) {
          const text = 'M/ - Abaixo do Esperado'
          return value = text
        }
      }
    },

    downloadExcel() { // Juvenil, Junior e Senior - Masculino
      const category = this.items.category

      if (category == 'JUVENIL I' || category == 'JUVENIL II') this.literature = this.items.juvenileDeadliftLiterature

      if (category == 'JUNIOR E SENIOR') this.literature = this.items.masculineDeadliftLiterature

      loading.push()
      GymRatingDeadLiftRepository.ExportExcelJuvAndSeniorMasculine(this.items.id, this.classAverage, this.literature, this.items.category, this.items.className)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          if(res.data.data === null) {
            toast.warning('Esta consulta não tem registros e não irá gerar planilha')
            loading.pop()
            return Promise.resolve()
          }

          const file = res.data.data
          const base64 = `data:${file.contentType};base64,${file.base64}`
          download(base64, file.alias, file.contentType)
          
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao exportar excel', 'ERRO')
        })
    },

    downloadExcelFemale() { // Junior e Senior - Feminino
      const category = this.items.category

      if (category == 'JUVENIL I' || category == 'JUVENIL II') return

      this.literature = this.items.feminineDeadliftLiterature

      loading.push()
      GymRatingDeadLiftRepository.ExportExcelSeniorFeminine(this.items.id, this.classAverageFeminine, this.literature, this.items.category, this.items.className)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          if(res.data.data === null) {
            toast.warning('Esta consulta não tem registros e não irá gerar planilha')
            loading.pop()
            return Promise.resolve()
          }

          const file = res.data.data
          const base64 = `data:${file.contentType};base64,${file.base64}`
          download(base64, file.alias, file.contentType)
          
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao exportar excel', 'ERRO')
        })
    },

    selectRow(item) {
      this.showModalDeleteDeadLift = true
      this.selected = item
      this.id = item.id
    },

    onDelete() {
      loading.push()
      GymRatingDeadLiftRepository.Delete(this.id)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.GetByGymRatingId(this.items.id)
          this.onCloseModalDeleteDeadLift()
          toast.success('Média zerada com sucesso!', 'EXCLUSÃO DE MÉDIA')
          this.$emit('reloadGraphicDeadLift', this.items.id, this.items.category)
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao excluir uma média de levantamento terra', 'ERRO')
        })
    },

    clearDrawer() {
      this.studentsDeadLift = []
      this.totalRegister = 0
      this.gymRatingDeadlift = new GymRatingDeadLiftModel()
      this.selected = {}
    },

    onCloseModalDeleteDeadLift() {
      this.selected = {}
      this.showModalDeleteDeadLift = false
    },

    onClearModalMeasurement() {
      this.measurement = new MeasurementModel()
      this.showModalMeasurement = false
    },

    onClearModalInputDeadLift() {
      this.gymRatingDeadlift.weight = null
      this.gymRatingDeadlift.deadLift = null
      this.showInputDeadLift = false
    },

    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    }
  }
}